import { I } from '@angular/cdk/keycodes';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ErrorStateMatcher } from '@angular/material/core';
import { CatalogDiagnosticMasterResponse, CatalogDiagnosticMasterFilter } from 'src/app/core/models/catalog/diagnostic.master.dto';
import { DiagnosticMasterService } from 'src/app/core/services/configuration/diagnostic_master.service';


@Component({
  selector: 'app-diagnostic-master-autocomplete',
  templateUrl: './diagnostic-master.autocomplete.component.html',
  styleUrls: ['./diagnostic-master.autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DiagnosticMasterAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DiagnosticMasterAutocompleteComponent),
      multi: true
    }
  ]
})
export class DiagnosticMasterAutocompleteComponent implements OnInit, ControlValueAccessor, Validator {

  @Input() label: string|null = null;
  @Input() placeholder: string = '';
  @Input() fechaAlta: Date = null;
  @Input() errorStr: string = '';
  @Input() maskSelection: string | null = null;
  @Input() patientId: number| null;
  @Input() required: boolean = false;
  public formSubmitted = false;

  @Input() rn15?: boolean;
  @Input() rn15IsDeath?: boolean
  @Input() pageSize: number = 25;
  @Input() errorStateMatcher!: ErrorStateMatcher;
  private static nextId = 0;
  public inputId = `diag-${DiagnosticMasterAutocompleteComponent.nextId++}`;
  @Input() showRequiredError: boolean = false;
  @Input() showRequiredIndicator: boolean = false;
  @Input() withoutRubricaTypeB: boolean = false;
  @Input() catalogKeyLength: number = 0;
  @Input() rnWoman1054: boolean = false;
  @Input() ignoreAfPrin: boolean = false;
  @Input() minLengthSearch?: number = 0;
  @Input() markControlAsTouched: boolean = false;
  // @Input() parentForm: FormGroup;
  // @Input() formControlNameStr: string = 'diagnosticMaster';

  @Output() isLoadingChange = new EventEmitter<boolean>();
  @Output() diagnosticMasChange = new EventEmitter<CatalogDiagnosticMasterResponse>();

  // AUTOCOMPLETE  DIAGNOSTICO MAESTRO
  public diagnosticMasterList: CatalogDiagnosticMasterResponse[] = [];
  public isLoading = false;

  public diagnosticMasterFormControl= new FormControl();

  private lastPatientId: number | null = null;

  /**
   *
   * @param diagMasterService
   */
  constructor( private diagMasterService: DiagnosticMasterService){

  }


  ngOnInit(): void {
    this.diagnosticMasterList = [];
    if (this.required) {
      this.diagnosticMasterFormControl.setValidators(Validators.required);
      this.diagnosticMasterFormControl.reset();
    }
    this.applyRequiredValidator();

  }

  clearDiagnosticNameIfNotSelected() {
    const currentValue = this.diagnosticMasterFormControl.value;
    const isOptionSelected = this.diagnosticMasterList.some(option => this.applyMaskSelection(option) === currentValue);
    if (!isOptionSelected) {
      this.diagnosticMasterFormControl.setValue(null);
      this.diagnosticMasChange.emit(null);
    }
  }

  // Event (input)
  onChangefilterDiagnosticMaster() {
    this.isLoadingChange.emit(true);
    this.isLoading = true;
    let diagStr: string = this.diagnosticMasterFormControl.value;
    if (diagStr && diagStr.length >= this.minLengthSearch) {
      var filters: CatalogDiagnosticMasterFilter = {
        fechaAlta: this.fechaAlta ? this.fechaAlta : null,
        page: 0,
        size: this.pageSize,
        diagnostic: diagStr,
        patientId: this.patientId,
        rn15 : this.rn15,
        rn15IsDeath : this.rn15IsDeath,
        withoutRubricaTypeB: this.withoutRubricaTypeB,
        rnWoman1054: this.rnWoman1054,
        ignoreAfPrin: this.ignoreAfPrin
      }
      this.diagMasterService.getAll(filters)
        .then((data) => {
          this.diagnosticMasterList = data.content;
          //Se filtra por una longitud definida
          if(this.catalogKeyLength > 0){
            this.diagnosticMasterList = this.diagnosticMasterList.filter(
              diag => diag.catalogKey.length == this.catalogKeyLength );
          }
        }).catch((error) => {
          console.error(error);
        }).finally(() => {
          this.isLoading = false;
          this.isLoadingChange.emit(false);
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['fechaAlta'] && changes['fechaAlta'].currentValue) {
  //   console.log('Fecha de alta recibida:', this.fechaAlta);
  //   this.fechaActualInput = new Date(this.fechaAlta);
  //   console.log('Fecha de alta convertida a Date:', this.fechaActualInput);
  // }
    if (changes['required']) { this.applyRequiredValidator(); }
    if (changes['patientId'] && changes['patientId'].currentValue !== this.lastPatientId) {
      this.lastPatientId = this.patientId;
      this.onChangefilterDiagnosticMaster();
    }
    if (changes['markControlAsTouched']) {
      this.markAsSubmitted();
    }
  }


  onDiagnosticItemSelected(event: MatAutocompleteSelectedEvent) {
    var option: CatalogDiagnosticMasterResponse = event.option.value;
    this.diagnosticMasterFormControl.setValue(this.applyMaskSelection(option));
    this.diagnosticMasChange.emit(option);
  }


  applyMaskSelection (diagnosticMasterSelected : CatalogDiagnosticMasterResponse) {
    if (this.maskSelection === null) {
      return diagnosticMasterSelected.nombre;
    }
    const maskSelectionVariables = this.maskSelection.match(/\${.*?}/g);
    let maskSelectionResult = this.maskSelection;
    maskSelectionVariables?.forEach(variable => {
      const variableName = variable.slice(2, -1);
      maskSelectionResult = maskSelectionResult.replace(variable, diagnosticMasterSelected[variableName]);
    });
    return maskSelectionResult;
  }


  // Implementación de ControlValueAccessor
  writeValue(value: any): void {
    this.diagnosticMasterFormControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.diagnosticMasterFormControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.diagnosticMasterFormControl.valueChanges.subscribe(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.diagnosticMasterFormControl.disable();
    } else {
      this.diagnosticMasterFormControl.enable();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.diagnosticMasterFormControl.errors;
  }

  private applyRequiredValidator(): void {
    if (this.required) {
      this.diagnosticMasterFormControl.setValidators(Validators.required);
    } else {
      this.diagnosticMasterFormControl.clearValidators();
    }
    this.diagnosticMasterFormControl.updateValueAndValidity({ emitEvent:false });
  }

  markAsSubmitted(): void {
    this.formSubmitted = true;
    this.diagnosticMasterFormControl.markAsTouched({ onlySelf: true });
  }
}
